"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  return props.flex === false ? 0 : props.flex === true ? 1 : props.flex;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flex/lib/props2flex.js
// module id = 3717
// module chunks = 0